import {Injectable} from "@angular/core";
import {AuthService} from "../services/auth.service";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import {Observable, ObservableInput, of, throwError, TimeoutError} from "rxjs";
import {catchError, tap, timeout} from "rxjs/operators";
import {Router} from "@angular/router";

@Injectable()
export class TokenInterceptor implements HttpInterceptor{

  constructor(
    private router: Router,
    private auth: AuthService){}


  intercept(req:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>>{

    if(this.auth.isAuthenticated()){

      req = req.clone({
        setHeaders: {
          Authorization: this.auth.getToken()
        }
      })

    }




    return next.handle(req).pipe(
      // Creating something while already over the quota is still allowed until
      // the rule takes effect. Saying so at exactly that moment is the whole
      // point: the customer is told while doing the thing that will stop
      // working, not in a notice they read later. Done here rather than in each
      // creation component so stream, video and upload all behave the same.
      tap((event: any) => {
        if (event && event.status && req.method === 'POST') {
          if (this.isCreation(req.url)) {
            const s = this.auth.storageStatus
            if (s && s.state === 'over' && !s.enforcing) {
              this.auth.storageWarnAfterCreate = true
            }
          }

          // Buying a plan changes the storage allowance, and the indicator has
          // to say so immediately rather than at the next poll a minute later.
          // The cabinet already refreshes itself after a storage purchase; this
          // makes a plan purchase behave the same way, from the same one place.
          if (this.isTariffChange(req.url)) {
            this.auth.storageWarnAfterCreate = false
            this.auth.loadStorageStatus().subscribe(()=>{}, ()=>{})
          }
        }
      }),
      catchError((error) => this.handleError(error))
    )

  }

  private isTariffChange(url: string): boolean {
    if (!url) { return false }
    return url.indexOf('/api/payments/request_buy_tariff') !== -1 ||
           url.indexOf('/api/payments/request_turn_on_tariff') !== -1
  }

  private isCreation(url: string): boolean {
    if (!url) { return false }
    return /\/api\/stream\/?($|\?)/.test(url) || /\/api\/videos(\/|\/upload\/|\/?$)/.test(url)
  }

  private handleError(error:HttpErrorResponse| Observable<any>  ):Observable<any> {


    /*if(error instanceof  TimeoutError){
    if(error.name === 'TimeoutError'){
        this.auth.logout()

       error = {
         error:{
           message: 'Возникли проблемы на сервере. Время ответа от сервера истекло'}
       }
      this.router.navigate(['/login'],{

      })

    }

    } */

    if(error instanceof  HttpErrorResponse) {
      // Creating anything new is refused while the account is over its storage
      // quota. Handling it here rather than at each call site means every path -
      // new stream, new video, upload - lights up the same explanation, and the
      // badge refreshes so the number the customer sees matches the refusal.
      if (error.status === 402 && error.error && error.error.reason === 'storage_over_quota') {
        this.auth.storageBlocked = true
        this.auth.loadStorageStatus().subscribe(()=>{}, ()=>{})
      }

      if (error.status === 401 && this.auth.isAuthenticated()) {
	 
        this.router.navigate(['/login'], {
          queryParams: {
            sessionFiled: true
          }
        })
      } else if(error.status === 406){


        this.router.navigate(['/overview'])

	} else  if (error.status === 423 && this.auth.isAuthenticated()) {
	 this.auth.logout()
        this.router.navigate(['/login'], {
          queryParams: {
            blocked: true
          }
        })
      }


    }

    return throwError(error)
  }

}
